<div class="login-page off-canvas-sidebar">
    <div>
        <div class="wrapper wrapper-full-page">
            <div filter-color="black" class="page-header login-page header-filter d-flex"
                style="background-image: url('./assets/img/login.jpg'); background-size: cover; background-position: top center;">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
                            <form [formGroup]="resetPasswordForm" class="form ng-untouched ng-pristine ng-valid">
                                <div class="card card-login">
                                    <div class="card-header card-header-rose text-center">
                                        <h4 class="card-title">Reset Password</h4>
                                    </div>
                                    <div class="card-body">
                                        <span class="bmd-form-group">
                                            <div class="input-group">
                                                <div class="input-group-prepend"><span class="input-group-text"><i
                                                            class="material-icons">email</i></span></div><input
                                                    type="password" placeholder="Password..." formControlName="password" class="form-control">
                                            </div>
                                        </span>
                                        <span class="bmd-form-group">
                                            <div class="input-group">
                                                <div class="input-group-prepend"><span class="input-group-text"><i
                                                            class="material-icons">lock_outline</i></span></div><input
                                                    type="password" placeholder="Confirm Password..." formControlName="confirmPassword" class="form-control">
                                            </div>
                                        </span>
                                        <span *ngIf="resetPasswordForm.controls['password'].value !== resetPasswordForm.controls['confirmPassword'].value &&
                                        resetPasswordForm.controls['password'].value !== '' && resetPasswordForm.controls['confirmPassword'].value !== ''" style="color: red; font-size: 12px; margin-left: 15px;">
                                            Password and Confirm Password not same
                                        </span>
                                    </div>
                                    <div class="card-footer justify-content-center">
                                        <a (click)="resetPassword()" class="btn btn-rose btn-link btn-lg">Reset Password</a></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <footer class="footer">
                    <div class="container">
                        <div class="copyright pull-right">
                            Version: {{ version }}
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</div>